/**等待中**/
<template>
  <div class="daijiaAwait">
    <div class="AwaitContent">
      <div class="page page1">
        <div class="upload">
          <div class="imgCircle">
            <img src="../../../assets/img/zhuanche/daijia_await_circle.png" :style="{transform: 'rotate('+rotateVal+'deg)'}">
          </div>
          <span class="imgMan"><img src="../../../assets/img/zhuanche/daijia_await_man.png"></span>
          <span class="awaitText">等待中</span>
        </div>
        <h2>
          请稍等正在为您联络司机
        </h2>
        <span class="cancelBut" @click="cancelOrderFn">取消订单</span>
      </div>
      <xk-Add :time="DjOrderInfo?DjOrderInfo.book_time:''"
              :origin="DjOrderInfo?DjOrderInfo.book_address:''"
              :endPoint="DjOrderInfo?DjOrderInfo.destination:''">
      </xk-Add>
    </div>
    <xk-input-box v-if="reson.state" title="取消订单理由" @click="cancelOrderFn" :closeState="true" :disabled="disabled">
      <div slot="content" class="DjCancelOrder">
        <textarea maxlength="50" v-model="reson.val" placeholder="请输入取消订单理由" @input="inputContentFn"></textarea>
      </div>
    </xk-input-box>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
    <xk-hint-box v-if="hintBox.stateShow" :state="hintBox.state" :content="hintBox.content"></xk-hint-box>
  </div>
</template>

<script>
  import XkAdd from '../../module/add/src/add.vue'
  import { mapGetters } from 'vuex'
  import XkInputBox from '../../module/inputBox/src/inputBox'
  import XkUploadMod from '../../module/uploadMod/src/uploadMod'
  import XkHintBox from '../../module/hintBox/src/hintBox'

  export default {
    components: {
      XkHintBox,
      XkUploadMod,
      XkInputBox,
      XkAdd
    },
    name: 'daijiaAwait',
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        DjOrderInfo: 'DjOrderInfo'
      })
    },
    data () {
      return {
        rotateVal: 0, // 旋转值
        reson: {
          state: false,
          val: ''
        },
        loadState: false,
        hintBox: {
          stateShow: false,
          state: 'yes',
          content: ''
        },
        disabled: true // 取消订单弹框的确认按钮是否禁用
      }
    },
    watch: {
      DjOrderInfo (val) {
        let that = this
        if (that.loginData.passenger && val && that.loginData.passenger.id !== val.passenger_id) {
          that.$router.push({path: '/daijia?app_key=' + window.configure.appKey})
          return
        }
        if (val.status === 1 || val.status === 5) {
          setTimeout(() => {
            if (that.$route.fullPath.split('?')[0] === '/daijia/await') {
              that.$store.dispatch('DjOrderInfo', {order_id: that.$route.query.order_id})
            }
          }, 3000)
        }
        if (val.status === 10 || val.status === 15 || val.status === 20) {
          that.$router.push({path: '/daijia/service', query: {order_id: that.$route.query.order_id}})
        }
        if (val.status === 35) {
          that.hintBox = {
            stateShow: true,
            state: 'yes',
            content: '您的订单已完成！'
          }
          setTimeout(() => {
            that.hintBox = false
            that.$router.push({path: '/daijia/affirm', query: {order_id: that.$route.query.order_id}})
            return false
          }, 1500)
          return
        }
        if (val.status === 45) {
          that.hintBox = {
            stateShow: true,
            state: 'no',
            content: '您的订单已被销单！'
          }
          setTimeout(() => {
            that.hintBox = false
            that.$router.push({path: '/daijia?app_key=' + window.configure.appKey})
            return false
          }, 1500)
          return
        }
      }
    },
    methods: {
      cancelOrderFn: function (val) {
        let that = this
        this.reson.state = !this.reson.state
        if (val === 'affirm') {
          if (this.reson.val !== '') {
            that.loadState = true
            this.$store.dispatch('putCancelOrder', {
              order_id: that.$route.query.order_id,
              remark: this.reson.val,
              fn: (state) => {
                that.loadState = false
                if (state && state.code === 1) {
                  this.reson.state = false
                  that.hintBox = {
                    stateShow: true,
                    state: 'yes',
                    content: '销单成功！'
                  }
                  setTimeout(() => {
                    that.hintBox.stateShow = false
                    that.$router.push({path: '/daijia?app_key=' + window.configure.appKey})
                  }, 1500)
                }
              }
            })
          } else {
            this.reson.state = true
            that.hintBox = {
              stateShow: true,
              state: 'no',
              content: '请输入销单理由！'
            }
            setTimeout(() => {
              that.hintBox.stateShow = false
            }, 1500)
          }
        }
      },
      inputContentFn () {
        if (this.reson.val) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      }
    },
    mounted: function () {
      let that = this

      function rotateFn () {
        setTimeout(function () {
          that.rotateVal = that.rotateVal + 8
          rotateFn()
        }, 39)
      }

      that.$store.dispatch('checkLogin', (sate) => {
        if (sate) {
          that.$store.dispatch('DjOrderInfo', {order_id: that.$route.query.order_id})
        }
      })

      rotateFn()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">


  .daijiaAwait {
    .AwaitContent {
      height: 100vh;
      width: 100vw;
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: auto;
      background-color: #f3f4f5;
      .page {
        margin-bottom: 1rem;
        background-color: #fff;
        box-shadow: 0 0 5px rgba(0, 0, 0, .1);
        text-align: center;
        padding: 2rem 0;
        .pageCarType {
          text-align: center;
          margin-top: 2.125rem;
          span {
            padding: 0 1rem;
            height: 1.8rem;
            line-height: 1.9rem;
            color: #fff;
            background-color: #f06553;
            font-size: 1rem;
            border-radius: 0.9rem;
          }
        }
        .upload {
          width: 100%;
          height: 11rem;
          text-align: center;
          margin-top: 0.625rem;
          position: relative;
          .imgCircle {
            img{
              height: 8rem;
              transform-origin: 50% 50%;
              transform: rotate(0);
            }
          }
          .imgMan {
            position: absolute;
            top: 2.620rem;
            left: 0;
            width: 100%;
            img{
              display: inline-block;
              margin: 0 auto;
              height: 2.725rem;
            }
          }
          .awaitText{
            margin-top: 0.725rem;
            font-size: 1.25rem;
            color: #222222;
          }
        }

        h2 {
          font-size: 0.8333rem;
          color: #999999;
          text-align: center;
        }
        .cancelBut {
          color: #f06553;
          font-size: 0.8333rem;
          margin-top: 1.525rem;
        }
      }
      .page1 {
        text-align: center;
        padding: 1rem 2rem;
        padding-bottom: 2rem;

      }
    }
    .DjCancelOrder {
      border: 1px solid #eee;
      height: 10rem;
      textarea {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: none;
        resize: none;
        font-size: 1rem;
        padding: 0.5rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// await.vue?40103f5d